import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default class Footer extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
    }

    render() {
        const { children } = this.props

        return <div className={'dialog-footer'}>{children}</div>
    }
}
